import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { saveAs } from 'file-saver';

import { PageableTableComponent } from '../../shared/controls/pageable-table/pageable-table.component';

import { InitializerService } from '../../shared/services/initializer-service';
import { ErrorService } from '../../shared/services/error-service';
import { LoadingService } from '../../shared/services/loading.service';
import { LoadingHelper } from '../../shared/services/loading-helper';

import { HasPermissionDirective } from '../../shared/directives/has-permission.directive';

import { AuditLogService, DownloadService, FilteredAuditLogItem, PagingData } from '../../../service/proxy';

@Component({
    templateUrl: './audit-log.component.html',
    styleUrls: ['./audit-log.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        PageableTableComponent,
        HasPermissionDirective,
    ],

    providers: [
        AuditLogService,
        DownloadService
    ]
})
export class AuditLogComponent implements OnInit {
    public search: string = '';
    public paging: PagingData = new PagingData();
    public auditLogs: FilteredAuditLogItem[] = [];
    public requestId: FilteredAuditLogItem[] = [];

    constructor(
        private auditLogService: AuditLogService,
        private router: Router,
        private downloadService: DownloadService,
        private initializerService: InitializerService,
        private errorService: ErrorService,
        private loadingService: LoadingService)
        {
            this.paging = this.initializerService.createPagingData();
        }

    ngOnInit(): void {
    }

    refreshGridData(): void {
        this.paging = this.initializerService.createPagingData();
        this.getAuditLogs(this.paging);
    }

    getAuditLogs(pagingData: PagingData = new PagingData): void {
        const request$ = this.auditLogService.getFilteredAuditLogs(
            this.search, 
            pagingData.pageNo, 
            pagingData.pageSize, 
            pagingData.sortDirection, 
            pagingData.sortColumn
        );

        LoadingHelper.withLoading(request$, this.loadingService)
            .subscribe({
                next: (data) => {
                    this.paging = data.pagingData;
                    this.auditLogs = data.results || [];
                },
                error: (error) => {
                    if (error.status === 204) {
                        this.auditLogs = [];
                        this.paging = this.initializerService.createPagingData();
                    }
                    else {
                        this.errorService.handleError(error);
                    }
                }
            });
    }

    getColumnMap() {
        return {
            requestId: 'Request Id',
            requestEmail: 'Request Email',
            method: 'Method',
            requestedUrl: 'Request URL',
            refererUrl: 'Referer URL',
            requestedAt: 'Requested At',
            responseTime: 'Response Time',
            numberOfErrors: 'Number of Errors',
        };
    }

    viewAuditResults(itemOrId: number | any): void {
        const requestId = (typeof itemOrId === 'number')
            ? itemOrId
            : (itemOrId?.requestId ?? itemOrId?.id ?? null);

        if (!requestId) {
            return;
        }

        this.router.navigate([`/audit-log-result/${requestId}`]);
    }

    downloadAuditLogs(pagingData: PagingData = new PagingData): void {
        const download$ = this.downloadService.downloadAuditLogs(
            this.search, 
            pagingData.pageNo, 
            pagingData.pageSize, 
            pagingData.sortDirection, 
            pagingData.sortColumn
        );
        
        LoadingHelper.withLoading(download$, this.loadingService)
            .subscribe({
                next: (response) => {
                    if (response.status === 200) {
                        saveAs(response.data, 'Audit_Logs.xlsx');
                    }
                    else {
                        alert('Download failed');
                    }
                },
                error: (error) => {
                    alert('Download failed');
                }
            });
    }
}